(() => {
    const initialize = () => {
        const page = document.querySelector('[data-us-product]');

        if (!page || page.dataset.initialized) return;

        page.dataset.initialized = 'true';
        const model = page.dataset.usProduct;

        page.querySelectorAll('.manuals a.guides-guide').forEach(async guide => {
            try {
                const response = await fetch(guide.href, { method: 'HEAD' });
                if (!response.ok) return;

                const size = Number(response.headers.get('Content-Length'));

                if (size > 0) {
                    const sizeInMB = (size / (1024 * 1024)).toFixed(2);
                    guide.querySelector('.guide-file-size').textContent = `, ${sizeInMB}MB`;
                }
            } catch {
                // Keep the download available when file-size metadata cannot be read.
            }
        });

        const reels = page.querySelector('.instagram-reels');

        if (reels) {
            const slider = reels.querySelector('.instagram-reels-slider');
            const track = reels.querySelector('.instagram-reels-slider-track');
            const arrows = reels.querySelectorAll('.slider-btn');

            const updateReels = () => {
                const overflowing = track.scrollWidth > slider.clientWidth + 1;
                slider.style.justifyContent = overflowing ? 'flex-start' : 'center';

                arrows.forEach(arrow => {
                    arrow.hidden = !overflowing;
                    arrow.classList.remove('hidden');
                });
            };

            arrows.forEach(arrow => {
                // Keep resizing reliable even when the shared script initially finds no overflow.
                arrow.addEventListener('click', event => {
                    event.stopImmediatePropagation();
                    const direction = arrow.classList.contains('ig-prev-btn') ? -1 : 1;
                    slider.scrollBy({
                        left: direction * 25 * parseFloat(getComputedStyle(slider).fontSize),
                        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
                    });
                }, true);
            });

            const observer = new ResizeObserver(updateReels);
            observer.observe(slider);
            observer.observe(track);
            updateReels();
        }

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const reveal = element => {
            if (reducedMotion.matches || !element) return;

            element.getAnimations().forEach(animation => animation.cancel());
            element.animate([
                { opacity: 0, transform: 'translateY(6px)' },
                { opacity: 1, transform: 'translateY(0)' }
            ], { duration: 200, easing: 'ease-out' });
        };

        // Match the homepage: one open answer, with smooth opening and closing.
        const accordionAnimations = new WeakMap();
        const setAnswer = (details, open) => {
            const startHeight = details.getBoundingClientRect().height;
            accordionAnimations.get(details)?.cancel();
            details.classList.toggle('is-closing', !open);
            details.open = true;
            details.style.height = '';

            const endHeight = open
                ? details.getBoundingClientRect().height
                : details.querySelector('summary').getBoundingClientRect().height
                    + parseFloat(getComputedStyle(details).borderTopWidth)
                    + parseFloat(getComputedStyle(details).borderBottomWidth);

            const finish = () => {
                details.open = open;
                details.classList.remove('is-closing');
                details.style.height = '';
                details.style.overflow = '';
                accordionAnimations.delete(details);
            };

            if (reducedMotion.matches) {
                finish();
                return;
            }

            details.style.overflow = 'hidden';
            const animation = details.animate([
                { height: `${startHeight}px` },
                { height: `${endHeight}px` }
            ], { duration: 200, easing: 'ease-out' });

            accordionAnimations.set(details, animation);
            animation.onfinish = finish;
        };

        page.querySelectorAll('.faqs details').forEach(details => {
            details.querySelector('summary').addEventListener('click', event => {
                event.preventDefault();
                const open = !details.open || details.classList.contains('is-closing');

                if (open) {
                    page.querySelectorAll('.faqs details[open]').forEach(sibling => {
                        if (sibling !== details) setAnswer(sibling, false);
                    });
                }

                setAnswer(details, open);
            });
        });

        page.querySelectorAll('[data-tab-group]').forEach(group => {
            const tabs = [...group.querySelectorAll('[role="tab"]')];
            const panels = group.querySelectorAll('[role="tabpanel"]');
            const descriptions = group.classList.contains('pizzas')
                ? [...panels].map(panel => ({ panel, text: panel.querySelector('p') })).filter(item => item.text)
                : [];
            const desktop = window.matchMedia('(min-width: 901px)');

            // Keep one copy of each description, beside its title on desktop.
            const positionDescriptions = () => {
                descriptions.forEach(({ panel, text }) => {
                    const tab = tabs.find(tab => tab.getAttribute('aria-controls') === panel.id);
                    text.hidden = panel.hidden;

                    if (desktop.matches) tab.after(text);
                    else panel.prepend(text);
                });
            };

            if (descriptions.length) {
                positionDescriptions();
                desktop.addEventListener('change', positionDescriptions);
            }

            const selectTab = selected => {
                tabs.forEach(tab => {
                    const active = tab === selected;
                    tab.setAttribute('aria-selected', active);
                    tab.tabIndex = active ? 0 : -1;
                });

                panels.forEach(panel => {
                    panel.hidden = panel.id !== selected.getAttribute('aria-controls');
                    if (!panel.hidden) reveal(panel);
                });

                positionDescriptions();
            };

            tabs.forEach((tab, index) => {
                tab.addEventListener('click', () => selectTab(tab));

                tab.addEventListener('keydown', event => {
                    let next = index;

                    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next++;
                    else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next--;
                    else if (event.key === 'Home') next = 0;
                    else if (event.key === 'End') next = tabs.length - 1;
                    else return;

                    event.preventDefault();
                    const selected = tabs[(next + tabs.length) % tabs.length];
                    selectTab(selected);
                    selected.focus({ preventScroll: true });
                });
            });
        });

        const fuelButtons = page.querySelectorAll('[data-fuel]');
        const fuelImages = page.querySelectorAll('[data-fuel-image]');
        const fuelPrices = page.querySelectorAll('[data-price-gas]');
        const gasItems = page.querySelectorAll('[data-gas-item]');

        fuelButtons.forEach(button => {
            button.addEventListener('click', () => {
                fuelButtons.forEach(option => {
                    const selected = option.dataset.fuel === button.dataset.fuel;
                    option.classList.toggle('selected', selected);
                    option.setAttribute('aria-pressed', selected);
                });

                fuelImages.forEach(image => {
                    image.hidden = image.dataset.fuelImage !== button.dataset.fuel;
                });

                fuelPrices.forEach(price => {
                    price.textContent = button.dataset.fuel === 'gas'
                        ? price.dataset.priceGas
                        : price.dataset.priceWood;
                });

                gasItems.forEach(item => {
                    item.hidden = button.dataset.fuel !== 'gas';
                });

                page.dataset.fuel = button.dataset.fuel;
            });
        });

        page.querySelectorAll('[data-capacity]').forEach(button => {
            button.addEventListener('click', () => {
                page.querySelectorAll('[data-capacity]').forEach(option => {
                    option.setAttribute('aria-pressed', option === button);
                });

                page.querySelector(`#${model}-${button.dataset.capacity}`).click();
                reveal(page.querySelector('.product-image > .media-placeholder'));
            });
        });

        const comparison = page.querySelector('[data-comparison]');

        comparison.querySelectorAll('[data-oven]').forEach(button => {
            button.addEventListener('click', () => {
                comparison.classList.toggle('show-raptor1', button.dataset.oven === 'r1');
                reveal(comparison.querySelector('.compare-images'));

                comparison.querySelectorAll('[data-oven]').forEach(option => {
                    const selected = option === button;
                    option.closest('.oven-option').classList.toggle('selected', selected);
                    option.setAttribute('aria-pressed', selected);
                });
            });
        });

        if (model === 'r1') {
            page.querySelector('.signup [data-value="raptor1"]').click();
        }
    };

    initialize();
    document.addEventListener('shopify:section:load', initialize);
})();
